<script setup>
import AppLayout from '@/layouts/AppLayout.vue'
import PhotoGallery from '@/components/PhotoGallery.vue'

defineProps({
  projet:          { type: Object, default: () => ({}) },
  estimation:      { type: Object, default: () => ({}) },
  photos:          { type: Array, default: () => [] },
  reports_url:     { type: String, default: null },
  compilation_url: { type: String, default: null },
  gallery_zip_request_url: { type: String, default: null },
})
</script>

<template>
  <AppLayout>
    <div class="p-8 space-y-6">
      <div class="flex items-start justify-between gap-4">
        <div>
          <div class="flex items-center gap-1.5 text-xs text-outline mb-1 flex-wrap">
            <a :href="projet.url" class="font-mono font-bold text-primary hover:brightness-125">{{ projet.code }}</a>
            <span class="material-symbols-outlined text-xs">chevron_right</span>
            <a :href="estimation.url" class="font-mono text-on-surface hover:text-primary">{{ estimation.code }}</a>
            <span class="material-symbols-outlined text-xs">chevron_right</span>
            <span class="text-outline">Galerie photo</span>
          </div>
          <h1 class="text-2xl font-black text-on-surface">Galerie photo</h1>
          <p class="text-sm text-outline mt-1">
            {{ photos.length }} photo{{ photos.length > 1 ? 's' : '' }}
          </p>
        </div>

        <div class="flex items-center gap-2">
          <a
            v-if="gallery_zip_request_url"
            :href="gallery_zip_request_url"
            class="machined-sheen px-4 py-2.5 rounded-md text-on-primary font-black text-xs uppercase tracking-widest flex items-center gap-1.5 hover:brightness-110 transition-all"
          >
            <span class="material-symbols-outlined text-sm">folder_zip</span>
            ZIP par courriel
          </a>
          <a
            v-if="compilation_url"
            :href="compilation_url"
            class="px-4 py-2.5 text-xs font-black uppercase tracking-widest rounded-md text-outline hover:text-on-surface bg-surface-container-low border border-outline-variant/10 transition-all flex items-center gap-1.5"
          >
            <span class="material-symbols-outlined text-sm">assessment</span>
            Compilation
          </a>
          <a
            v-if="reports_url"
            :href="reports_url"
            class="px-4 py-2.5 text-xs font-black uppercase tracking-widest rounded-md text-outline hover:text-on-surface bg-surface-container-low border border-outline-variant/10 transition-all flex items-center gap-1.5"
          >
            <span class="material-symbols-outlined text-sm">list</span>
            Rapports
          </a>
        </div>
      </div>

      <PhotoGallery
        :photos="photos"
        :show-source="true"
        empty-message="Aucune photo n'est disponible pour cette estimation."
      />
    </div>
  </AppLayout>
</template>
